
export const validateIsZero = (values, allValues) => {
    if (values === "0") {
       return "Please more than 0"
    }
 }